import { render, staticRenderFns } from "./MailScheduleInfo.vue?vue&type=template&id=f4daf778&"
import script from "./MailScheduleInfo.vue?vue&type=script&lang=ts&"
export * from "./MailScheduleInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports